<script setup lang="ts">
defineProps<{
    date: string;
}>();
</script>

<template>
  <div class="flex items-center gap-3 my-4">
    <div class="flex-1 h-px bg-gray-200" />
    <time class="text-xs text-gray-400 px-2 py-0.5 bg-gray-100 rounded-full whitespace-nowrap">
      {{ date }}
    </time>
    <div class="flex-1 h-px bg-gray-200" />
  </div>
</template>
